var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelationCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9375 5C6.45527 5 6.875 4.58027 6.875 4.0625C6.875 3.54473 6.45527 3.125 5.9375 3.125C5.41973 3.125 5 3.54473 5 4.0625C5 4.58027 5.41973 5 5.9375 5ZM5.9375 5.625C6.80044 5.625 7.5 4.92544 7.5 4.0625C7.5 3.19955 6.80044 2.5 5.9375 2.5C5.07455 2.5 4.375 3.19955 4.375 4.0625C4.375 4.92544 5.07455 5.625 5.9375 5.625Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.75H5V4.375H0V3.75Z",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 9.375C8.95527 9.375 9.375 8.95527 9.375 8.4375C9.375 7.91973 8.95527 7.5 8.4375 7.5C7.91973 7.5 7.5 7.91973 7.5 8.4375C7.5 8.95527 7.91973 9.375 8.4375 9.375ZM8.4375 10C9.30044 10 10 9.30044 10 8.4375C10 7.57455 9.30044 6.875 8.4375 6.875C7.57455 6.875 6.875 7.57455 6.875 8.4375C6.875 9.30044 7.57455 10 8.4375 10Z",
    fill: "#474747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0H0V5.625C0 7.35089 1.39911 8.75 3.125 8.75H7.08333V8.125H3.125C1.74429 8.125 0.625 7.00571 0.625 5.625V0Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationCount);
export default __webpack_public_path__ + "static/media/relation-count.b1b7db8304dd0fb214755ee164d2cf32.svg";
export { ForwardRef as ReactComponent };